import LineItemDisplay from '@/components/ui/LineItemDisplay'

// Mantine
import { SegmentedControl } from '@mantine/core'

// React
import { useState } from 'react'

export default function LineItemsList({
    lines,
    markLineAsReady,
    markLineAsNotReady,
    ...lineProps
}) {
    const sortByName = (a, b) => {
        const aName =
            a.component?.name ||
            a.shopify_product_variant?.shopify_product?.title ||
            a.name ||
            ''
        const bName =
            b.component?.name ||
            b.shopify_product_variant?.shopify_product?.title ||
            b.name ||
            ''
        return aName.localeCompare(bName)
    }

    const [filter, setFilter] = useState('all')

    const filteredLines =
        filter === 'all'
            ? lines
            : filter === 'ready'
              ? lines.filter((l) => l.is_ready)
              : lines.filter((l) => !l.is_ready)

    const readyCount = lines.filter((l) => l.is_ready).length
    const notReadyCount = lines.length - readyCount

    const hasComponents = lines.some((l) => l.component)
    const hasVariants = lines.some((l) => !l.component)

    const componentLines = filteredLines
        .filter((l) => l.component)
        .sort(sortByName)
    const variantLines = filteredLines
        .filter((l) => !l.component)
        .sort(sortByName)

    const canFilter = !!(markLineAsReady || markLineAsNotReady)

    return (
        <div className="flex flex-col gap-2">
            {canFilter && (
                <SegmentedControl
                    value={filter}
                    onChange={setFilter}
                    data={[
                        { label: `Tous (${lines.length})`, value: 'all' },
                        { label: `Préparés (${readyCount})`, value: 'ready' },
                        {
                            label: `À préparer (${notReadyCount})`,
                            value: 'not_ready',
                        },
                    ]}
                />
            )}

            {hasComponents && (
                <div className="flex flex-col">
                    {componentLines.length > 0 ? (
                        <div className="flex flex-col divide-y border rounded-lg overflow-hidden">
                            {componentLines.map((line) => (
                                <LineItemDisplay
                                    key={line.id}
                                    line={line}
                                    markLineAsReady={markLineAsReady}
                                    markLineAsNotReady={markLineAsNotReady}
                                    {...lineProps}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="py-4 text-sm text-gray-400 text-center border rounded-lg">
                            Aucune ligne
                        </div>
                    )}
                </div>
            )}
            {hasVariants && (
                <div className="flex flex-col">
                    {variantLines.length > 0 ? (
                        <div className="flex flex-col divide-y border rounded-lg overflow-hidden">
                            {variantLines.map((line) => (
                                <LineItemDisplay
                                    key={line.id}
                                    line={line}
                                    markLineAsReady={markLineAsReady}
                                    markLineAsNotReady={markLineAsNotReady}
                                    {...lineProps}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="py-4 text-sm text-gray-400 text-center border rounded-lg">
                            Aucune ligne
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
